import type { CSSProperties, FC } from "react";

import classNames from "classnames";
import _ from "lodash";

import { UpgradeLink } from "app/components/React/Table/cells/UpgradeLink";
import { i18nFilter } from "app/filters/i18nFilter";
import { trafficSourcesSearchHrefFilter } from "app/filters/ngFilters";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { WebsiteTooltip } from "../../Tooltip/WebsiteTooltip/WebsiteTooltip";
import type { ITableCellProps } from "../interfaces/ITableCellProps";
import { trackEvent } from "../SWReactTableTrackEvent";

import { QualificationSideBarCellButton } from "./QualificationSideBarCellButton";
interface IKeywordAnalysisTrafficSourceProps extends ITableCellProps {
    handleOpenQualificationSideBar?: (row: any) => void;
    onCellClick?: (e: FixmeType, index: number, isEnrichedRowTriggerClick?: boolean) => void;
}
export const KeywordAnalysisTrafficSource: FC<IKeywordAnalysisTrafficSourceProps> = ({
    value,
    row,
    toggleChildRows,
    showMoreChildRows,
    visibleParents,
    tableOptions,
    webSource,
    handleOpenQualificationSideBar,
    onCellClick,
}) => {
    const children = row.Children || [];
    const isChild = row.parent;
    const isExpanded = _.result(visibleParents, `${row.index}.expanded`);
    const showMore = isChild && row.isLast && row.index + 1 !== row.parent.childsCount;
    const showMoreStyle: CSSProperties = showMore ? { position: "relative", top: "-6px" } : {};
    const classes = classNames("swTable-rowToggle", isExpanded ? "sw-icon-collapse" : "sw-icon-expand");
    const i18n = i18nFilter();
    const favicon = row.Icon || row.Favicon;

    return (
        <>
            <div className="domain-cell">
                {children.length ? (
                    <i
                        className={classes}
                        onClick={() => toggleChildRows(row, value)}
                    />
                ) : null}
                <div
                    className="swTable-keywordCell"
                    style={showMoreStyle}
                >
                    {favicon ? (
                        <img
                            alt=""
                            src={favicon}
                            className="favicon"
                        />
                    ) : null}

                    {value !== "grid.upgrade" ? (
                        <WebsiteTooltip
                            domain={value}
                            handleOpenQualificationSideBar={
                                handleOpenQualificationSideBar
                                    ? (e) => {
                                          if (typeof onCellClick === "function") {
                                              onCellClick(e, -1);
                                          }
                                          handleOpenQualificationSideBar({
                                              Domain: value,
                                              Favicon: favicon,
                                          });
                                      }
                                    : undefined
                            }
                        >
                            <a
                                href={row.href ?? trafficSourcesSearchHrefFilter(proNavigator)(value, webSource)}
                                className="text"
                            >
                                <span
                                    className="swTable-content"
                                    onClick={() => trackEvent(tableOptions, "Internal Link", value, "click")}
                                >
                                    {value}
                                </span>
                            </a>
                        </WebsiteTooltip>
                    ) : (
                        <UpgradeLink hookType="website" />
                    )}
                    {children.length ? <span className="u-vAlignMiddle">({children.length})</span> : null}
                    <a
                        className="swTable-linkOut sw-link-out"
                        href={`http://${value}`}
                        onClick={() => trackEvent(tableOptions, "External Link", value, "click")}
                        target="_blank"
                        rel="noreferrer"
                    />
                </div>
                {showMore ? (
                    <button
                        className="swTable-showMore showMore-margin"
                        onClick={() => showMoreChildRows(row, value)}
                    >
                        {i18n("grid.showmore")}
                    </button>
                ) : null}
            </div>
            {handleOpenQualificationSideBar ? (
                <QualificationSideBarCellButton
                    domain={value}
                    favicon={favicon}
                    handleOpenQualificationSideBar={handleOpenQualificationSideBar}
                />
            ) : null}
        </>
    );
};

KeywordAnalysisTrafficSource.displayName = "KeywordAnalysisTrafficSource";
